import React from "react";
import l from "components/util/l";

const getInitials = (firstWord, secondWord) =>
	(firstWord ?? "").length > 0 ? firstWord.charAt(0).toUpperCase() : "" +
		(secondWord ?? "").length > 0 ? secondWord.charAt(0).toUpperCase() : ""

const SharedPersonItem = ({
	participant,
	roleOptions,
	owner,
	isOwner = false,
	onChangeParticipantRole,
	onClickChangeOrganizationParticipantRole,
	onClickRemoveParticipant
}) => (
	<div>

		<div className="d-flex justify-content-between align-items-center py-3">
			<div class="d-flex align-items-center">
				<div class={`avatar avatar-soft-primary avatar-circle`}>
					<span class="avatar-initials">
						{
							function(){
								if (isOwner)
									return getInitials(owner.firstName, owner.lastName);
								else if (participant.organization)
									return getInitials(participant.organization.name);
								else if (participant.user)
									return getInitials(participant.user.firstName, participant.user.lastName);
								else if (participant.email)
									return getInitials(participant.email);
								else if (participant.phone)
									return getInitials(participant.phone);
							}()
						}
					</span>
				</div>
				<div class="ml-3">
					<span class="d-block h5 text-hover-primary mb-0">

						{
							function() {
								if (isOwner)
									return owner?.firstName + " " + owner?.lastName;
								else if (participant.user)
									return participant.user.firstName + " " + participant.user.lastName;
								else if (participant.email)
									return participant.email;
								else if (participant.phone)
									return participant.phone;
								else if (participant.organization)
									return participant.organization.name;
							}()
						}

						{
								participant?.organization && (
									<button 
										type="button"
										className="btn btn-link ml-3 p-0 m-0"
										data-toggle="collapse" 
										data-target={`#collapse-organization-${participant.id}`}
										aria-expanded="false" 
										aria-controls={`collapse-organization-${participant.id}`}
									>
										Ver Permisos <i class="fas fa-angle-down"></i>
									</button>
								)
							}

					</span>
					<span class="d-block font-size-sm text-body">
						{
							function() {
								if (isOwner)
									return owner?.email ?? owner?.phone;
								else if (participant.user)
									return participant.user.email ?? participant.user.phone;
								else if (participant.email)
									return participant.email;
								else if (participant.phone)
									return participant.phone;
							}()
						}
					</span>
				</div>
			</div>

			{
				isOwner 
					? <span className="h5">
							{l("Titular%PA034")}
						</span> 
					: <div className="d-flex">

							<select class="custom-select mr-3" onChange={(e) => onChangeParticipantRole(participant.id, e.target.value)}>
								{roleOptions.map((role) => (
									<option key={role.value} value={role.value} selected={participant.role.id == role.value}>
										{role.label}
									</option>
								))}
							</select>
							<button className="btn btn-sm btn-lighter" style={{borderColor: "#e7eaf3"}} 
								onClick={() => onClickRemoveParticipant(participant.id)}>
								<i class="fas fa-user-minus"></i>
							</button>

						</div>
			}
		</div>

		{
			participant?.organization && (
				<div className="collapse" id={`collapse-organization-${participant.id}`}>
					<div className="card card-body py-1">
						{
							participant?.organization?.organizationParticipants?.map((orgParticipant, idx) => (
								orgParticipant?.user?.id != owner?.id && 
								<div className="d-flex justify-content-between align-items-center py-3" key={`org-participant-${idx}`}>
									<div class="d-flex align-items-center">
										<div class={`avatar avatar-soft-primary avatar-circle`} >
											<span class="avatar-initials">
												{getInitials(orgParticipant.user.firstName, orgParticipant.user.lastName)}
											</span>
										</div>
										<div class="ml-3">
											<span class="d-block h5 text-hover-primary mb-0">
												{
													function() {
														if (orgParticipant.user)
															return orgParticipant.user.firstName + " " + orgParticipant.user.lastName;
														else if (orgParticipant.email)
															return orgParticipant.email;
														else if (orgParticipant.phone)
															return orgParticipant.phone;
													}()
												}
											</span>
											<span class="d-block font-size-sm text-body">
												{
													function() {
														if (orgParticipant.user)
															return orgParticipant.user.email ?? orgParticipant.user.phone;
														else if (orgParticipant.email)
															return orgParticipant.email;
														else if (orgParticipant.phone)
															return orgParticipant.phone;
													}()
												}
											</span>
										</div>
									</div>
									<div className="d-flex">
										<select 
											class="custom-select mr-3" 
											onChange={(e) => 
												onClickChangeOrganizationParticipantRole(participant, orgParticipant, e.target.value)}
											value={participant.settings?.roles?.[orgParticipant.user.id] || participant.role.id}
										>
											{roleOptions.map((role) => (
												<option 
													key={role.value} 
													value={role.value} 
												>
													{role.label}
												</option>
											))}
										</select>
									</div>
								</div>
							))
						}
					</div>
				</div>
			)
		}

	</div>
)

export default SharedPersonItem;